const defaults = {
    adminUrl: '',
    countries: [],
    currency: {
        code: 'USD',
        precision: 2,
        symbol: '$',
        symbolPosition: 'left',
        decimalSeparator: '.',
        priceFormat: '%1$s%2$s',
        thousandSeparator: ',',
    },
    currentUserIsAdmin: false,
    homeUrl: '',
    locale: {
        siteLocale: 'en_US',
        userLocale: 'en_US',
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
    orderStatuses: [],
    placeholderImgSrc: '',
    siteTitle: '',
    storePages: [],
    wcAssetUrl: '',
    wcVersion: '',
    wpLoginUrl: '',
    wpVersion: '',
};

const globalSharedSettings = typeof window.wcSettings === 'object' ? window.wcSettings : {};

// Use defaults or global settings, depending on what is set.
const allSettings = {
    ...defaults,
    ...globalSharedSettings,
};

allSettings.currency = {
    ...defaults.currency,
    ...allSettings.currency,
};

allSettings.locale = {
    ...defaults.locale,
    ...allSettings.locale,
};

export { allSettings };
